import { ref } from 'vue';
import { API_BASE, PUBLICATION_STATE } from '../constants.js';

const allMapIds = (async () => {
  const response = await fetch(
    `${API_BASE}/kategorien?publicationState=${PUBLICATION_STATE}&populate[kartenansichten][fields][0]=id&fields[0]=id`
  );
  const data = await response.json();
  const allIndizes = [];
  data.data.map((oneKat) =>
    oneKat.attributes.kartenansichten.data.map((oneMap) =>
      allIndizes.push(oneMap.id)
    )
  );
  return allIndizes;
})();

export const useRandomMap = () => {
  const randomMapId = ref(0);
  allMapIds.then((allIndizes) => {
    randomMapId.value =
      allIndizes[Math.floor(Math.random() * allIndizes.length)];
  });
  return { randomMapId };
};
